import { StyleSheet } from 'react-native';

const ResourceMovieImage = ({ style }) => {
  const oneX = require('./resource-movie.jpg');
  const twoX = require('./resource-movie@2x.jpg');
  return (
    <img
      src={twoX}
      alt=""
      style={{ ...StyleSheet.flatten(style), objectFit: 'cover' }}
      srcSet={`${oneX}, ${twoX} 2x`}
    />
  );
};

export { ResourceMovieImage };
